import React from 'react';

import appContent from '@/services/content/appContent';
import {twx} from '@/utils/tailwindUtils';

import {ButtonRaw} from '../Button';
import CloseCircleIcon from '../Icons/CloseCircleIcon';

const CloseCircleButton = ({onClick, className, 'aria-label': propsAriaLabel, fill}) => {
    const {closeButton} = appContent.getGlobalButtons() || {};
    const alt = propsAriaLabel ?? closeButton?.alt;

    return (
        <ButtonRaw className={twx('cursor-pointer', className)} onClick={onClick} aria-label={alt}>
            <CloseCircleIcon fill={fill} />
        </ButtonRaw>
    );
};

export default CloseCircleButton;
